import React, { useState } from 'react'
import { CopyToClipboard } from "react-copy-to-clipboard";

interface CopyButtonProps {
  businessId: string
}

const CopyButton = (props: CopyButtonProps) => {
	const [isCopied, setIsCopied] = useState(false);

	const onCopyToClipboard = () => {
		setIsCopied(true);
		setTimeout(() => setIsCopied(false), 2000);
	};

	return (
		<CopyToClipboard text={props.businessId} onCopy={() => onCopyToClipboard()}>
			<span className="copy-button" title="Copy">
				<i className={`fa-light fa-${isCopied ? "check" : "copy"}`}></i>
			</span>
		</CopyToClipboard>
	);
};

export default CopyButton